// Libs
import React, { useEffect, useState } from 'react';

// Own Libs
import { SimpleView, CompositeView, GridView } from '@digital/ui';

//Api
import {
  DemandaComRequisicao,
  getAllDemandasComRequisicaoComStatus
} from '@app/api/requisitanteCapex';

//Files
import TabelaDemandas from '../tabelaDemandas';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';

//Utils

const ValidacaoCapex = () => {
  const result: DemandaComRequisicao[] = [];
  const [demandasAguardandoAnaliseControleFinanceiro, setDemandasAguardandoAnaliseControleFinanceiro] = useState<DemandaComRequisicao[]>();

  const allDemandasAguardandoAnaliseControleFinanceiro = async () => {
    const resultDemanda = await getAllDemandasComRequisicaoComStatus(EStatusDemanda.AguardandoAnaliseControleFinanceiro) || [];
    const resultDemandaModificacao = await getAllDemandasComRequisicaoComStatus(EStatusDemanda.AguardandoAnaliseControleFinanceiroModificacao) || [];
    const resultDemandaReavaliacao = await getAllDemandasComRequisicaoComStatus(EStatusDemanda.AguardandoAnaliseControleFinanceiroReavaliacao) || [];
    setDemandasAguardandoAnaliseControleFinanceiro([...resultDemanda, ...resultDemandaModificacao, ...resultDemandaReavaliacao]);
  };

  useEffect(() => {
    allDemandasAguardandoAnaliseControleFinanceiro();
  }, []);

  return (
    <SimpleView>
      <CompositeView>
        <GridView title="Pendencias Validação Econômica" icon="ui-in_progress" id="aguardandoValidacaoCAPEX" noform>
          <TabelaDemandas
            idtabela="mrn-tabela-aguardandoValidacaoCAPEX"
            dataSourceResult={demandasAguardandoAnaliseControleFinanceiro ? demandasAguardandoAnaliseControleFinanceiro : result}
            widgettitle={'Validação Econômica'}
            urlDemanda={'/demanda/questionario/'}
            aba={'/analise'}
          />
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};
export default ValidacaoCapex;
